/** Module-level stack for nested Modal portals (scroll / Escape / z-index / focus). */

type ModalStackEntry = { id: number };

let openModalCount = 0;
let nextModalId = 1;
const modalStack: ModalStackEntry[] = [];

export function registerModal(): { id: number; depth: number; unregister: () => void } {
  const id = nextModalId++;
  openModalCount += 1;
  modalStack.push({ id });
  document.body.style.overflow = 'hidden';
  const depth = openModalCount;

  return {
    id,
    depth,
    unregister: () => {
      openModalCount = Math.max(0, openModalCount - 1);
      const idx = modalStack.findIndex((m) => m.id === id);
      if (idx >= 0) modalStack.splice(idx, 1);
      if (openModalCount === 0) {
        document.body.style.overflow = 'unset';
      }
    },
  };
}

export function isTopModal(id: number): boolean {
  const top = modalStack[modalStack.length - 1];
  return !!top && top.id === id;
}

export function hasOpenModals(): boolean {
  return openModalCount > 0;
}

export function modalZIndex(depth: number): number {
  return 50 + Math.max(0, depth - 1) * 10;
}
